// INFO: Update the translations in the i18n files when the enum is updated. Translations are based on the enum keys.
export enum InspectionStatus {
  completed = 'COMPLETED',
  draft = 'DRAFT',
  imported = 'IMPORTED',
  submitted = 'SUBMITTED',
  takeInCharge = 'TAKE IN CHARGE',
  toReview = 'TO REVIEW',
}
